import { Footer } from '@/previewThemes/lumera/Footer';
import { Header } from '@/previewThemes/lumera/Header';
import { Product } from '@/previewThemes/lumera/Product';
import {
  lumeraProductParts,
  lumeraProductSections,
} from '@/previewThemes/lumera/productPage';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  listing: {
    // Three across beside the filter rail: a beauty card is mostly photograph,
    // and at four columns beside a 240px rail the picture shrinks below the
    // size that sells a serum.
    grid: 'grid-cols-2 gap-6 lg:grid-cols-3',
    filters: 'sidebar',
    columns: 3,
    card: 'framed',
  },
  cart: { grid: 'mt-10 grid gap-10 lg:grid-cols-3', panel: 'filled' },
  checkout: {
    grid: 'mt-10 grid items-start gap-10 lg:grid-cols-[minmax(0,1fr)_24rem] lg:gap-14',
    panel: 'filled',
  },
  search: {
    grid: 'mt-10 grid gap-10 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-6 lg:grid-cols-3',
    columns: 3,
    card: 'framed',
    panel: 'bare',
  },
  blog: { list: 'grid gap-8 sm:grid-cols-2 lg:grid-cols-3', title: 'text-2xl' },
  // Three across, large: the department index is a set of photographs a
  // shopper chooses a mood from, not a directory to scan.
  category: { grid: 'grid gap-6 sm:grid-cols-2 lg:grid-cols-3', tile: 'card' },
  pages: {
    product: { defaults: lumeraProductSections },
  },
  parts: {
    product_details: {
      defaults: lumeraProductParts,
      presentation: {
        classes: {
          product_title: 'text-3xl sm:text-[2.5rem] leading-tight',
          product_price: 'text-3xl font-semibold',
          product_short_description: 'text-[14px]',
        },
        wideButtons: true,
        gallery: { aspect: 'square', thumbs: 'below' },
      },
    },
  },
};
